// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ov-0";
export var discountCodeInput = "_ov-1";